import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, formatarValor } from '../../common/utils';
import Paginacao from '../../common/pagination';

class Produtos extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaProduto = this.buscaProduto.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            page_numb: 1,
            loading: true,
        };
    }

    componentDidMount(){
        this.consultaRegistro(this.state.busca, this.state.page_numb)
    }

    consultaRegistro(busca, page_numb=1){
        api.get(`/produtos/?nome=${busca}&page=${page_numb}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar produtos, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.nome}</td>
                <td>{item.ean}</td>
                <td>{(item.valor) ? 'R$ ' + formatarValor(item.valor) : ''}</td>
                <td>
                    <Button variant="light" href={"/produtos/edit/"+item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button>    
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={5}>Nenhum produto cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca, num_page)
    };

    buscaProduto(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaRegistro(this.state.busca)
    };

    render() {
        if (!hasPerm('view_produtos')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Produtos</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/produtos/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Produto
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaProduto}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="busca"
                                                                value={this.state.busca}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Nome do produto"
                                                                aria-label="Nome do produto"
                                                                aria-describedby="basic-addon2"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>

                                {/*<Button variant="light" className="ms-2" size="sm">
                                    <FaFileExport /> Exportar
                                </Button>*/}
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>EAN</th>
                                    <th>Valor</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={5}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={5}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Produtos);